// "The Potion Shop has restocked" — a top-of-screen banner wherever the
// player is, the moment a ten-minute stock cycle rolls over. Silent until the
// Potion Shop is unlocked (spec §4). A one-second ticker on the wall clock,
// installed once from main.ts alongside the effect timers.
import { cycleIndex, restockStep } from '../config/potions';
import { potionShopUnlocked } from '../config/hub';
import { RankService } from '../services/rankService';
import { hubProgress } from '../render/hubShared';
import { saveStorage } from '../render/saveStorage';
import { enqueueBanner } from './messageBanner';
import { potionEpoch } from '../account/potionRestock';

export const RESTOCK_BANNER_SENDER = 'Potion Shop';
export const RESTOCK_BANNER_TEXT = 'Stock has restocked!';

let timer: ReturnType<typeof setInterval> | undefined;

/** Whether the player would see the banner right now. Exported for tests. */
export function restockBannerWanted(): boolean {
  try {
    const rank = new RankService(saveStorage()).rank();
    return potionShopUnlocked(rank, (f) => hubProgress().hasFlag(f));
  } catch {
    return false;
  }
}

export function installRestockWatch(now: () => number = Date.now): void {
  if (timer) return;
  let last = cycleIndex(now(), potionEpoch());
  timer = setInterval(() => {
    const step = restockStep(last, now(), potionEpoch());
    last = step.cycle;
    if (step.rolled && restockBannerWanted()) {
      enqueueBanner(RESTOCK_BANNER_SENDER, RESTOCK_BANNER_TEXT);
    }
  }, 1000);
}

export function uninstallRestockWatch(): void {
  clearInterval(timer);
  timer = undefined;
}
